import React from 'react';

const SelectBarTriangle = () => (
    <div className="option-select-bar">
        <div className="option-select-bar--triangle" />
    </div>
);

export default SelectBarTriangle;

SelectBarTriangle.displayName = 'SelectBarTriangle';
